import { useVarifyClass } from '@/composables/useVarifyClass';
import type { Ref } from 'vue';

/** Set on <html> by the Varify variant that shows the filters next to the results instead of behind the Filter button. */
export const varifyInlineFiltersClass = 'varify-inline-filters';

/** False during SSR and hydration; the server always renders the default layout, CSS reserves the variant's space. */
export function useVarifyInlineFilters(): Readonly<Ref<boolean>> {
    return useVarifyClass(varifyInlineFiltersClass);
}
